export type DayKey =
  | 'MONDAY'
  | 'TUESDAY'
  | 'WEDNESDAY'
  | 'THURSDAY'
  | 'FRIDAY'
  | 'SATURDAY'
  | 'SUNDAY';

export interface DaySchedule {
  enabled: boolean;
  startTime: string; // 'HH:mm'
  endTime: string; // 'HH:mm'
}

export type WeekScheduleForm = Record<DayKey, DaySchedule>;

export const DAY_ORDER: readonly DayKey[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
] as const;

export const DAY_LABEL_KEYS: Record<DayKey, string> = {
  MONDAY: 'config-day-monday',
  TUESDAY: 'config-day-tuesday',
  WEDNESDAY: 'config-day-wednesday',
  THURSDAY: 'config-day-thursday',
  FRIDAY: 'config-day-friday',
  SATURDAY: 'config-day-saturday',
  SUNDAY: 'config-day-sunday'
};

export const DEFAULT_START_TIME = '08:00';
export const DEFAULT_END_TIME = '16:00';
export const DEFAULT_WORKING_DAYS: readonly DayKey[] = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY'
] as const;
